import { type IconName } from 'core/ui/components/icon/Icon'

import { type EquipmentType } from '../../core/domain/EquipmentType'

type EquipmentTypes = {
  label: string
  icon: IconName
}

type AllEquipmentTypes = {
  [key in EquipmentType]?: EquipmentTypes
}

const equipmentTypes: AllEquipmentTypes = {
  DryBox: {
    label: 'Dry Box',
    icon: 'truck-container',
  },
  DryVan: {
    label: 'Dry Van',
    icon: 'dryvan',
  },
  'Bulk Pneumatics': {
    label: 'Bulk Pneumatics',
    icon: 'truck-dryvan',
  },
  'Bulk Tanker': {
    label: 'Bulk Tanker',
    icon: 'truck-dryvan',
  },
  Conestoga: {
    label: 'Conestoga',
    icon: 'conestoga',
  },
  Flatbed: {
    label: 'Flatbed',
    icon: 'truck-flatbed',
  },
  FlatRack: {
    label: 'Flat Rack',
    icon: 'truck-flatrack',
  },
  Hotshot: {
    label: 'Hotshot',
    icon: 'truck-hotshot',
  },
  'Power Only': {
    label: 'Power Only',
    icon: 'truck-bobtail',
  },
  'Reefer or Vented Van': {
    label: 'Reefer or Vented Van',
    icon: 'truck-ventilated',
  },
  Reefer: {
    label: 'Reefer',
    icon: 'truck-reefer',
  },
  'Roll on Roll off': {
    label: 'Roll on Roll off',
    icon: 'truck-rollon-rolloff',
  },
  'Straight Box Truck': {
    label: 'Straight Box Truck',
    icon: 'truck-straight',
  },
  Sprinter: {
    label: 'Sprinter',
    icon: 'truck-sprinter',
  },
  SuperB: {
    label: 'SuperB',
    icon: 'truck-dryvan',
  },
}

export function getEquipmentType(equipmentType: EquipmentType) {
  return equipmentTypes[equipmentType]
}
